import AutoSuggestion from "./AutoSuggestion";

export default AutoSuggestion;
